import { create } from 'zustand';
import type { FlowSample } from '@tiw/shared-types';

/**
 * Flow store.
 *
 * Holds the latest live `tiw.flow.tick` sample per link, keyed by link id.
 * Replaced wholesale each tick (~2 Hz). The globe reads it to modulate each
 * traffic arc's brightness/speed by live utilization. See useRealtimeStream
 * and docs/EVENT_ARCHITECTURE.md.
 */
interface FlowState {
  readonly byLink: Readonly<Record<string, FlowSample>>;
  apply: (samples: readonly FlowSample[]) => void;
}

export const useFlowStore = create<FlowState>((set) => ({
  byLink: {},
  apply: (samples) =>
    set(() => {
      const next: Record<string, FlowSample> = {};
      for (const s of samples) next[s.link_id] = s;
      return { byLink: next };
    }),
}));
